/**
 * This module contains the project pages
 *
 * @module app/pages/Pages
 */
/**
 * Object containing public
 * functions exposed by this
 * component
 *
 * @type {Object}
 */
var api = {
    getFallback: async () => {
        const { default: fallback } = await import(/* webpackChunkName: "FallbackPage" */'./FallbackPage');
        return fallback;
    },
    getHighlights: async () => {
        const module = await import(/* webpackChunkName: "HighlightsPage" */'./HighlightsPage');
        return module.default;
    },
    getCompetitions: async () => {
        const module = await import(/* webpackChunkName: "CompetitionsPage" */'./CompetitionsPage');
        return module.default;
    },
    getEvent: async () => {
        const module = await import(/* webpackChunkName: "EventPage" */'./EventPage');
        return module.default;
    },
    getEventsMulti: async () => {
        const module = await import(/* webpackChunkName: "EventsMultiPage" */'./EventsMultiPage');
        return module.default;
    },
    getMatches: async () => {
        const module = await import(/* webpackChunkName: "MatchesPage" */'./MatchesPage');
        return module.default;
    },
    getDailyMatchList: async () => {
        const module = await import(/* webpackChunkName: "DailyMatchListPage" */'./DailyMatchListPage');
        return module.default;
    },
    getMeetings: async () => {
        const module = await import(/* webpackChunkName: "MeetingsPage" */'./MeetingsPage');
        return module.default;
    },
    getRacing: async () => {
        const module = await import(/* webpackChunkName: "RacingPage" */'./RacingPage');
        return module.default;
    },
    getAntePost: async () => {
        const module = await import(/* webpackChunkName: "AntePostPage" */'./AntePostPage');
        return module.default;
    },
    getSpecials: async () => {
        const module = await import(/* webpackChunkName: "SpecialsPage" */'./SpecialsPage');
        return module.default;
    },
    getTopBets: async () => {
        const module = await import(/* webpackChunkName: "TopBetsPage" */'./TopBetsPage');
        return module.default;
    },
    getRewards: async () => {
        const module = await import(/* webpackChunkName: "RewardsPage" */'./RewardsPage');
        return module.default;
    },
    getLotteries: async () => {
        const module = await import(/* webpackChunkName: "LotteriesPage" */'./LotteriesPage');
        return module.default;
    },
    getResults: async () => {
        const module = await import(/* webpackChunkName: "ResultsPage" */'./ResultsPage');
        return module.default;
    },
    getVirtual: async () => {
        const module = await import(/* webpackChunkName: "VirtualPage" */'./VirtualPage');
        return module.default;
    },
    getSchedule: async () => {
        const module = await import(/* webpackChunkName: "SchedulePage" */'./SchedulePage');
        return module.default;
    },
    getInPlay: async () => {
        const module = await import(/* webpackChunkName: "InPlayPage" */'./InPlayPage');
        return module.default;
    },
    getHome: async () => {
        const module = await import(/* webpackChunkName: "HomePage" */'./HomePage');
        return module.default;
    },
    getCoupons: async () => {
        const module = await import(/* webpackChunkName: "CouponsPage" */'./CouponsPage');
        return module.default;
    },
    getPromotions: async () => {
        const module = await import(/* webpackChunkName: "PromotionsPage" */'./PromotionsPage');
        return module.default;
    },
    getTote: async () => {
        const module = await import(/* webpackChunkName: "TotePage" */'./TotePage');
        return module.default;
    },
    getJockeysTrainers: async () => {
        const module = await import(/* webpackChunkName: "JockeysTrainersPage" */'./JockeysTrainersPage');
        return module.default;
    },
    getStaticSEO: async () => {
        const module = await import(/* webpackChunkName: "StaticSEOPage" */'./StaticSEOPage');
        return module.default;
    },
    getTournaments: async () => {
        const module = await import(/* webpackChunkName: "TournamentsPage" */'./TournamentsPage');
        return module.default;
    },
    getNaps: async () => {
        const module = await import(/* webpackChunkName: "NapsPage" */'./NapsPage');
        return module.default;
    },
    getInternationalRacing: async () => {
        const module = await import(/* webpackChunkName: "InternationalRacingPage" */'./InternationalRacingPage');
        return module.default;
    },
};

export default api;
